import React, { useState, useContext,  useEffect } from 'react'
import { IconCheck } from '../../svg/index'
import Modal from "react-modal";
import { DataContext } from '../../data/DataContext';
const Step1 = () => {
    const { VivirSeguro, setVivirSeguro } = useContext(DataContext);
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    useEffect(() => {
        handleShow();
    },[])


    return (
        <div className="step">
            <div className="step-container-vivirseguro">
                <div className="mt-15 mb-30">
                    <span className="title2">
                        Antes de iniciar, record&aacute; tener a mano la siguiente informaci&oacute;n:
                </span>
                </div>
                <div>
                    <div className="group-p mt-10 pl-30" >
                        <IconCheck />
                        <span className="txt1">Documento de identificaci&oacute;n</span>
                    </div>
                    <div className="group-p mt-10 pl-30" >
                        <IconCheck />
                        <span className="txt1">Tarjeta de d&eacute;bito o cr&eacute;dito</span>
                    </div>
                    <div className="group-p mt-10 pl-30" >
                        <IconCheck />
                        <span className="txt1">Informaci&oacute;n de tus beneficiarios </span>
                    </div>
                </div>
                <div className="mt-50 mb-50 pl-30">
                    <input type="checkbox" name="acceptaTermino" checked={VivirSeguro.acceptaTermino} onChange={e => setVivirSeguro({ ...VivirSeguro, acceptaTermino: e.target.checked })} className="" name="acceptaTerminos" id="acceptaTerminos" required />
                    <a rel='noreferrer' onClick={handleShow} target='_blank' className="terminoscondiciones">Acepto términos y condiciones de uso</a>
                </div>
            </div>
            <Modal className="modal" isOpen={show} show={show} ariaHideApp={false} autoFocus={false} onHide={handleClose} autoFocus={false}>
                <div className="modal-title">
                    <span className="txt-title-modal">Términos y condiciones para solicitar en línea</span>
                </div>
                <div className="modal-body-info">
                    <p className="title4">Al completar este formulario, usted declara que los datos particulares que ha proporcionado son correctos y solicita a Seguros LAFISE la emisi&oacute;n de una p&oacute;liza de seguro de acuerdo a las condiciones especificadas en el entendido que cualquier declaraci&oacute;n falsa o inexacta sobre su estado de salud anula el presente contrato.</p>
                    <p className="title4"><strong>Nota Importante:</strong> Este formulario no debe entenderse como aceptaci&oacute;n de la cobertura por parte de Seguros LAFISE hasta su confirmaci&oacute;n y el pago de la prima en la forma de pago convenida.</p>
                </div>
                <div className="modal-footer">
                    <button type="button" tabindex="-1" className="modal-btn-close" onClick={handleClose}>Cerrar</button>
                </div>
            </Modal>
        </div>
    );

}
export default Step1;